import { Link } from "react-router-dom";
import { MapPin, Ruler, Package, Clock, Heart, Rocket, Pencil } from "lucide-react";
import { tl } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { STATUS_LABELS, timeAgo } from "@/lib/categories";

export function JobCard({ job, onFav, favorited }) {
  const { user } = useAuth();
  const admin = user?.role === "admin";
  const budget = job.budget_min || job.budget_max
    ? `${job.budget_min ? new Intl.NumberFormat("tr-TR").format(job.budget_min) : "0"} - ${job.budget_max ? tl(job.budget_max) : ""}`
    : "Görüşülecek";
  return (
    <div className={`bg-white rounded-2xl overflow-hidden hover-lift flex flex-col sm:flex-row ${job.is_boosted ? "border-2 border-emerald-500 shadow-md shadow-emerald-500/10" : "border border-slate-200/80"}`} data-testid={`job-card-${job.id}`}>
      {job.photos && job.photos[0] && (
        <div className="sm:w-52 h-40 sm:h-auto shrink-0 bg-slate-100">
          <img src={job.photos[0]} alt={job.title} className="w-full h-full object-cover" loading="lazy" />
        </div>
      )}
      <div className="flex-1 p-5 flex flex-col">
        <div className="flex items-start justify-between gap-3">
          <div className="flex items-center gap-2">
            <span className="inline-block text-xs font-bold text-emerald-700 bg-emerald-50 px-2.5 py-1 rounded-full">{job.category_name}</span>
            {job.is_boosted && <span className="inline-flex items-center gap-1 text-xs font-bold text-white brand-gradient px-2.5 py-1 rounded-full" data-testid={`job-boosted-${job.id}`}><Rocket className="h-3 w-3" /> Öne Çıkan</span>}
          </div>
          <div className="flex items-center gap-2">
            {admin && <Link to={`/ilan/${job.id}`} title="Yönetici düzenle" data-testid={`job-admin-edit-${job.id}`} className="text-violet-600 hover:text-violet-700"><Pencil className="h-5 w-5" /></Link>}
            {onFav && (
              <button data-testid={`job-fav-${job.id}`} onClick={() => onFav(job.id)} className="text-slate-300 hover:text-emerald-500">
                <Heart className={`h-5 w-5 ${favorited ? "fill-emerald-500 text-emerald-500" : ""}`} />
              </button>
            )}
          </div>
        </div>
        <Link to={`/ilan/${job.id}`}>
          <h3 className="text-lg font-bold text-slate-900 mt-2 hover:text-emerald-600 transition-colors">{job.title}</h3>
        </Link>
        <p className="text-sm text-slate-500 mt-1 line-clamp-2 leading-relaxed">{job.description}</p>
        <div className="flex flex-wrap items-center gap-x-4 gap-y-1.5 mt-3 text-xs text-slate-500">
          <span className="flex items-center gap-1"><MapPin className="h-3.5 w-3.5 text-emerald-500" /> {job.city} / {job.district}</span>
          {job.area_m2 && <span className="flex items-center gap-1"><Ruler className="h-3.5 w-3.5 text-emerald-500" /> {job.area_m2}</span>}
          {job.material_status && <span className="flex items-center gap-1"><Package className="h-3.5 w-3.5 text-emerald-500" /> {job.material_status}</span>}
          <span className="flex items-center gap-1"><Clock className="h-3.5 w-3.5 text-emerald-500" /> {timeAgo(job.created_at)}</span>
        </div>
        <div className="mt-4 pt-3 border-t border-slate-100 flex items-center justify-between">
          <div>
            <div className="text-[11px] text-slate-400">Tahmini Bütçe</div>
            <div className="font-bold text-slate-900">{budget}</div>
          </div>
          <div className="flex items-center gap-2">
            {job.status && <span className="text-[11px] font-semibold text-emerald-600 bg-emerald-50 px-2 py-1 rounded-full">{STATUS_LABELS[job.status] || job.status}</span>}
            <Link to={`/ilan/${job.id}`} data-testid={`job-detail-link-${job.id}`}
              className="text-sm font-semibold text-emerald-700 border border-emerald-200 px-4 py-2 rounded-xl hover:bg-emerald-50 transition-colors">
              Detayları Gör →
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
